import { useEffect, useRef, useState } from 'react';
import { setActor } from '../lib/awsdb';
import { validatePin } from '../lib/auth';
import './pin.css';

const SESSION_KEY = 'fon-objectives-session';

export function readStoredSession() {
  try { return JSON.parse(localStorage.getItem(SESSION_KEY) || 'null'); }
  catch { return null; }
}

export function clearStoredSession() {
  localStorage.removeItem(SESSION_KEY);
}

export default function PinScreen({ onAuthed }) {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);
  const [wiggle, setWiggle] = useState(0);
  const busyRef = useRef(false);

  useEffect(() => {
    function onKey(e) {
      if (/^[0-9]$/.test(e.key)) {
        setPin(p => (p.length < 4 ? p + e.key : p));
        setWiggle(w => w + 1);
      } else if (e.key === 'Backspace') {
        setPin(p => p.slice(0, -1));
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  useEffect(() => {
    if (pin.length === 4 && !busyRef.current) {
      busyRef.current = true;
      (async () => {
        const { data, error: err } = await validatePin(pin);
        if (err || !data) {
          setError('Try again');
          setShake(true);
          setTimeout(() => { setPin(''); setError(''); setShake(false); busyRef.current = false; }, 600);
          return;
        }
        const session = { code: data.code, name: data.name, role: data.role };
        localStorage.setItem(SESSION_KEY, JSON.stringify(session));
        await setActor(session);
        busyRef.current = false;
        onAuthed(session);
      })();
    }
  }, [pin, onAuthed]);

  return (
    <div className="auth-screen" onClick={() => document.activeElement?.blur()}>
      <div className="auth-container">
        <div className={`auth-logo ${shake ? 'shake' : ''} ${wiggle ? 'wiggle' : ''}`}
          onAnimationEnd={() => setWiggle(0)}
          key={wiggle}
        >
          FON
        </div>
        {error && <div className="auth-error">{error}</div>}
      </div>
    </div>
  );
}
